<template>
    <div style="padding: 14px 18px 33px;" :data-userid="userInfo ? userInfo.userId : ''">
        <div class="flexLayout" :data-userid="userInfo ? userInfo.id : ''">
            <div style="width: 80px;">
                <div class="imageArea circle hiddenOverflow" style="height: 80px; border: solid 1px #BBBBBB;"
                    :data-headerImg="userInfo ? userInfo.headerImg : ''">
                    <img class="fullSpace cover" :src="userInfo.headerImg" v-if="userInfo && userInfo.headerImg"/>
                </div>
            </div>
            <div class="marginL16 flexItem">
                <div class="font12r" style="padding-top:  12px;">
                    {{ userInfo ? userInfo.userName : '' }}
                    <span class="textLabel roleLabel alignM">至尊会员</span>

                    <span class="orange marginL8">未认证</span>
                    <span class="orange marginL8">已认证</span>
                </div>
                <!--                        <div class="font14r" style="margin-top: 16px;">-->
                <!--                            合作截止时间：2022-xx-xx-->
                <!--                        </div>-->
<!--                <div class="font14r marginT16">-->
<!--                    加入日期：{{ userInfo ? formatDate(userInfo.createTime) : '' }}-->
<!--                </div>-->
                <div class="font14r marginT16">
                    有效期：{{ userInfo ? formatDate(userInfo.expireTime) : '' }}
                    <span class="continueButton marginL8">续费</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modulePart from "@comp/part/modulePart";
export default {
    name: "kindergartenVipPersonalHeader",
    extends : modulePart,
    props : {
        userInfo : Object
    }
}
</script>

<style scoped>

.orange {
    color: #E99D42;
}
.green {
    color: #42A238;
}
.roleLabel {
    padding: 0 8px;
    height: 27px;
    line-height: 27px;
    font-size: 14px;
    text-align: center;
    background: transparent;
    border: solid 1px #BBBBBB;
    color: #101010;
}
.continueButton {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    font-size: 14px;
    background: #E99D42;
    color: white;
    padding: 0 1.5ex;
    border-radius: 4px;
}
</style>